module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"today":"Today","yesterday":"Yesterday"},"de":{"today":"Heute","yesterday":"Gestern"},"fr":{"today":"Aujourd\u0027hui","yesterday":"Hier"},"it":{"today":"Oggi","yesterday":"Ieri"}}')
  delete Component.options._Ctor
}
